export function hasUsableVideoFrame(video, stream) {
	if (!video || !stream || typeof stream.getVideoTracks !== 'function') return false;
	const hasActiveTrack = stream.getVideoTracks().some(track => track
		&& track.readyState === 'live'
		&& track.enabled !== false
		&& track.muted !== true);
	return hasActiveTrack
		&& video.readyState >= 2
		&& video.videoWidth > 2
		&& video.videoHeight > 2;
}
